import React, { FC } from 'react'

import { IconStateWarnProps } from './IconStateWarn.types'
import * as Styled from './styles/IconStateWarn.style'

import { nonThemeableRules } from '../../ruleSet'

const IconStateWarn: FC<IconStateWarnProps> = ({
  size = nonThemeableRules.defaultSize as number as IconStateWarnProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconStateWarnProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <defs>
          <path id='4139e920-d8f5-4d06-b1c4-8ba0f3aded9d__a' d='M0 .004h159.936v142.07H0z' />
        </defs>
        <g fill='none' fillRule='evenodd'>
          <g transform='translate(0 8.328)'>
            <mask id='4139e920-d8f5-4d06-b1c4-8ba0f3aded9d__b' fill='#fff'>
              <path d='M0 .004h159.936v142.07H0z' />
            </mask>
            <path
              d='M68.343 6.716c5.167-8.949 18.083-8.949 23.25 0l33.262 57.612 33.262 57.613c5.167 8.948-1.291 20.134-11.624 20.134H13.443c-10.333 0-16.791-11.186-11.625-20.134l33.263-57.613L68.343 6.716Z'
              fill='#E99600'
              mask='url(#4139e920-d8f5-4d06-b1c4-8ba0f3aded9d__b)'
            />
          </g>
          <path
            d='M79.968 116.172a6.554 6.554 0 1 0 0 13.11 6.554 6.554 0 0 0 0-13.11m-4.387-15.588s-.06 1.234.519 2.494c.626 1.525 2.124 2.608 3.868 2.608 1.743 0 3.242-1.083 3.868-2.608.579-1.26.519-2.494.519-2.494l1.05-24.044 1.061-24.314c.286-6.563-6.195-6.839-6.195-6.839h-.606s-6.482.276-6.195 6.839l1.06 24.314 1.05 24.044Z'
            fill='#333'
          />
        </g>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconStateWarn
